'use client'

import { useEffect, useRef, useState } from 'react'

/**
 * BrandLogo — Sassu animated brand mark
 *
 * Hover'imisel mängib SASSU letter loop animatsioon (S → A → S → S → U → S).
 * Tagasi default state'i pärast 5 loopi või leave'l.
 *
 * Kasutatud landing pages SiteHeader'is.
 */
export function BrandLogo({ size = 40, fontSize = 15 }: { size?: number; fontSize?: number }) {
  const letters = ['S', 'A', 'S', 'S', 'U']
  const [char, setChar] = useState('S')
  const timersRef = useRef<ReturnType<typeof setTimeout>[]>([])

  const startLoop = () => {
    // Cleanup eelmised
    timersRef.current.forEach(clearTimeout)
    timersRef.current = []
    setChar('S')

    const step = 200
    const loopDuration = letters.length * step
    const totalLoops = 3 // landing page'is lühem kui /sisene'l (5 loopi)

    for (let loop = 0; loop < totalLoops; loop++) {
      letters.forEach((l, i) => {
        timersRef.current.push(
          setTimeout(() => setChar(l), loop * loopDuration + i * step)
        )
      })
    }
    // Tagasi S'ile pärast viimast loopi
    timersRef.current.push(
      setTimeout(() => setChar('S'), totalLoops * loopDuration)
    )
  }

  const stopLoop = () => {
    timersRef.current.forEach(clearTimeout)
    timersRef.current = []
    setChar('S')
  }

  useEffect(() => {
    return () => timersRef.current.forEach(clearTimeout)
  }, [])

  return (
    <div
      onMouseEnter={startLoop}
      onMouseLeave={stopLoop}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        background: '#111',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        flexShrink: 0,
        transition: 'transform 200ms ease',
      }}
    >
      <span
        style={{
          color: '#fff',
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
          fontSize: `${fontSize}px`,
          fontWeight: 800,
          letterSpacing: '0.02em',
          lineHeight: 1,
          transition: 'color 100ms ease',
        }}
      >
        {char}
      </span>
    </div>
  )
}
